var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaracleOfficialMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 275,
    viewBox: "0 0 408 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1225_2172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.521 9.12266C224.554 -4.88986 197.803 -1.06826 183.437 17.4028L182.729 18.3228L45.1518 204.944L44.5148 205.864C31.0685 225.043 35.3855 251.794 54.3519 265.736C73.6014 279.961 100.919 275.785 115.144 256.536L252.721 69.9144C266.946 50.6648 262.77 23.3475 243.521 9.12266Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.303 9.05067L389.383 8.41374C370.487 -4.74954 344.302 -0.786401 330.148 17.3308L329.44 18.2508L191.863 204.872L191.226 205.792C177.779 224.971 182.096 251.722 201.063 265.664C220.312 279.889 247.63 275.713 261.855 256.464L399.432 69.8423C413.657 50.5928 409.481 23.2755 390.232 9.05067H390.303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.891 51.9454C103.891 23.3542 80.5366 0 51.9454 0C23.3542 0 0 23.3542 0 51.9454C0 62.7733 3.39697 72.8934 9.12937 81.2443L47.6284 133.897C48.9023 135.525 52.5823 139.064 56.8993 133.119L94.8322 81.2443C100.565 72.8934 103.962 62.7733 103.962 51.9454H103.891Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1225_2172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408,
    height: 274.186,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaracleOfficialMark);
export default __webpack_public_path__ + "static/media/waracle-official-mark.e2fcd38cc98476c2faf9ad85e2b3c8c7.svg";
export { ForwardRef as ReactComponent };